export default __webpack_public_path__ + "static/media/logo_simples.d5133cf5.png";